import { StyleSheet } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  cardRoot: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 16,
    borderColor: theme.colors.cardBackgroundColor,
    borderWidth: 1,
  }),
  elevation_low: theme => ({
    borderRadius: 6,
    shadowColor: theme.name === 'light' ? Colors.blackThree : Colors.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 5,
  }),
  elevation_high: theme => ({
    borderRadius: 7,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.32,
    shadowRadius: 10,
    elevation: 8,
  }),
  cardWithTitle: {
    borderTopLeftRadius: 0,
  },
  selectedCard: {
    borderWidth: 1,
    borderStyle: 'solid',
  },
  title: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    width: '70%',
  },
})
